// extracted by mini-css-extract-plugin
module.exports = {"controls":"Controls__controls__-jz-o","control":"Controls__control__VRAB5"};